// extracted by mini-css-extract-plugin
module.exports = {"root":"AltMessagesEditor_root__ME-TK","standaloneInsertButton":"AltMessagesEditor_standaloneInsertButton__2CmL_"};